import { useMemo } from "react"
import i18next from "i18next"
import { environment } from "modules/environments"
import { FEDERATION_GLB, FEDERATION_GN } from "views/constants/jsonData/globalData"

export const languagesCodeMap = {
  [FEDERATION_GN]: "zh-TW",
  [FEDERATION_GLB]: "en-PH",
}

export const languagesMap = {
  "en-US": "English",
  "zh-TW": "中文",
}

export const useLanguages = () => {
  const switchLanguage = (language) => i18next.changeLanguage(language)
  const currentLanguage = i18next.language
  const languages = useMemo(() => {
    const languageCodes = currentLanguage === "zh-TW" ? ["zh-TW", "en-US"] : ["en-US", "zh-TW"]
    const languageList = languageCodes.map((code) => ({
      code,
      name: languagesMap[code],
    }))

    // Add CIMode option only in development
    if (environment !== "production") {
      languageList.push({
        code: "cimode",
        name: "⚙️",
      })
    }

    return languageList
  }, [currentLanguage])

  return { languages, switchLanguage, language: currentLanguage }
}
